module.exports = "https://tutorchat.chegg.com/static/media/ic-shape-circle.405b8e5f.svg";